<div>
  <div class="form-group row mt-2">
    <div class="col-sm-2">
      De :
    </div>
    <div class="col-sm-4 form-inline">
      <select ngModel class="form-control custom-select-sm" id="beginDay" [(ngModel)]="criteres.beginDay"
              name="beginDay" #beginDay="ngModel">
        <option *ngFor="let day of days" [value]="day" [selected]="day === criteres.beginDay">{{ day }}</option>
      </select>
      /
      <select ngModel class="form-control custom-select-sm" id="beginMonth" [(ngModel)]="criteres.beginMonth"
              name="beginMonth" #beginMonth="ngModel">
        <option *ngFor="let month of months" [value]="month" [selected]="month === criteres.beginMonth">{{ month }}
        </option>
      </select>
      /
      <select ngModel class="form-control custom-select-sm" id="beginYear" [(ngModel)]="criteres.beginYear"
              name="beginYear" #beginYear="ngModel">
        <option *ngFor="let year of years" [value]="year" [selected]="year === criteres.beginYear">{{ year }}</option>
      </select>
      &nbsp;
      <select ngModel class="form-control custom-select-sm" id="beginHour" [(ngModel)]="criteres.beginHour"
              name="beginHour" #beginHour="ngModel">
        <option *ngFor="let hour of hours" [value]="hour" [selected]="hour === criteres.beginHour">{{ hour }}</option>
      </select>
      :
      <select ngModel class="form-control custom-select-sm" id="beginMinute" [(ngModel)]="criteres.beginMinute"
              name="beginMinute" #beginMinute="ngModel">
        <option *ngFor="let minute of minutes" [value]="minute" [selected]="minute === criteres.beginMinute">{{ minute
          }}
        </option>
      </select>
    </div>
    <div class="col-sm-2">
      A :
    </div>
    <div class="col-sm-4 form-inline">
      <select ngModel class="form-control custom-select-sm" id="endDay" [(ngModel)]="criteres.endDay"
              name="endDay" #endDay="ngModel">
        <option *ngFor="let day of days" [value]="day" [selected]="day === criteres.endDay">{{ day }}</option>
      </select>
      /
      <select ngModel class="form-control custom-select-sm" id="endMonth" [(ngModel)]="criteres.endMonth"
              name="endMonth" #endMonth="ngModel">
        <option *ngFor="let month of months" [value]="month" [selected]="month === criteres.endMonth">{{ month }}
        </option>
      </select>
      /
      <select ngModel class="form-control custom-select-sm" id="endYear" [(ngModel)]="criteres.endYear"
              name="endYear" #endYear="ngModel">
        <option *ngFor="let year of years" [value]="year" [selected]="year === criteres.endYear">{{ year }}</option>
      </select>
      &nbsp;
      <select ngModel class="form-control custom-select-sm" id="endHour" [(ngModel)]="criteres.endHour"
              name="endHour" #endHour="ngModel">
        <option *ngFor="let hour of hours" [value]="hour" [selected]="hour === criteres.endHour">{{ hour }}</option>
      </select>
      :
      <select ngModel class="form-control custom-select-sm" id="endMinute" [(ngModel)]="criteres.endMinute"
              name="endMinute" #endMinute="ngModel">
        <option *ngFor="let minute of minutes" [value]="minute" [selected]="minute === criteres.endMinute">{{ minute
          }}
        </option>
      </select>
    </div>
  </div>
  <div class="form-group row">
    <div class="col-sm-2">
      Environement :
    </div>
    <div class="col-sm-2">
      <select ngModel class="form-control" id="environment" [(ngModel)]="criteres.environment"
              name="environment" #environment="ngModel">
        <option *ngFor="let e of environments" [value]="e" [selected]="e === criteres.environment">{{ e }}</option>
      </select>
    </div>
    <div class="col-sm-2">
      Domaine :
    </div>
    <div class="col-sm-2">
      <select ngModel class="form-control" id="domain" [(ngModel)]="criteres.domain"
              name="domain" #domain="ngModel" (change)="onChangeDomain($event.target.value)">
        <option *ngFor="let d of domains" [value]="d" [selected]="d === criteres.domain">{{ d }}</option>
      </select>
    </div>
    <div class="col-sm-2">
      Application :
    </div>
    <div class="col-sm-2">
      <select ngModel class="form-control" id="application" [(ngModel)]="criteres.application"
              name="application" #application="ngModel">
        <option *ngFor="let a of applications" [value]="a" [selected]="a === criteres.application">{{ a }}</option>
      </select>
    </div>
  </div>
  <div class="form-group row">
    <div class="col-sm-2">
      Niveau :
    </div>
    <div class="col-sm-2">
      <select ngModel class="form-control" id="level" [(ngModel)]="criteres.level"
              name="level" #level="ngModel">
        <option *ngFor="let l of levels" [value]="l" [selected]="l === criteres.level">{{ l }}</option>
      </select>
    </div>
    <div class="col-sm-2">
      Structure :
    </div>
    <div class="col-sm-2">
      <input ngModel type="text" class="form-control" id="structure" [(ngModel)]="criteres.structure" name="structure"
             #structure="ngModel">
    </div>
    <div class="col-sm-2">
      User :
    </div>
    <div class="col-sm-2">
      <input ngModel type="text" class="form-control" id="login" [(ngModel)]="criteres.login" name="login"
             #login="ngModel">
    </div>
  </div>
  <div class="form-group row">
    <div class="col-sm-2">
      Health checks :
    </div>
    <div class="col-sm-2">
      <select ngModel class="form-control" id="nohealth" [(ngModel)]="criteres.nohealth"
              name="nohealth" #nohealth="ngModel">
        <option value="false" [selected]="criteres.level !== 'true'">Afficher</option>
        <option value="true" [selected]="criteres.level === 'true'">Masquer</option>
      </select>
    </div>
    <div class="col-sm-2">
      Dur&eacute;e :
    </div>
    <div class="col-sm-2">
      <select ngModel class="form-control" id="duration" [(ngModel)]="criteres.duration"
              name="duration" #duration="ngModel">
        <option value="0" [selected]="criteres.duration === 0">Toutes</option>
        <option value="1000" [selected]="criteres.duration === 1000">> 1s</option>
        <option value="2000" [selected]="criteres.duration === 2000">> 2s</option>
        <option value="5000" [selected]="criteres.duration === 5000">> 5s</option>
        <option value="10000" [selected]="criteres.duration === 10000">> 10s</option>
        <option value="30000" [selected]="criteres.duration === 30000">> 30s</option>
      </select>
    </div>
    <div class="col-sm-2">
    </div>
    <div class="col-sm-2">
      <button type="button" class="btn btn-outline-secondary" (click)="rechercher()">
        Rechercher
      </button>
    </div>
  </div>
</div>

<table class="table table-responsive-lg table-hover table-bordered" *ngIf="tableauAAfficher">
  <thead class="thead-light">
    <tr>
      <th style="width: 20%;">
        <span *ngIf="resultats.page > 1" style="cursor: pointer;"><a (click)="changerPage(resultats.page - 1)">Page précédente</a></span>
      </th>
      <th colspan="2" style="width: 20%;">
        <span *ngIf="resultats.page < resultats.pages" style="cursor: pointer;"><a (click)="changerPage(resultats.page + 1)">Page suivante</a></span>
      </th>
      <th colspan="6">
        Page {{ resultats.page }} sur {{ resultats.pages }}
      </th>
    </tr>
    <tr>
      <th>Date/Heure</th>
      <th>Niveau</th>
      <th>Domaine</th>
      <th>Environement</th>
      <th>Application</th>
      <th>Structure</th>
      <th>User</th>
      <th>Path</th>
      <th>Status</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let item of resultats.items" style="cursor: pointer" (click)="selectItem(item.id)">
      <td>
        {{ item.time }}
      </td>
      <td [ngStyle]="levelStyle(item.level)">
        {{ item.level }}
      </td>
      <td>
        {{ item.domain }}
      </td>
      <td>
        {{ item.environment }}
      </td>
      <td>
        {{ item.application }}
      </td>
      <td>
        {{ item.structure }}
      </td>
      <td>
        {{ item.login }}
      </td>
      <td>
        {{ item.path }}
      </td>
      <td [ngStyle]="statusStyle(item.status)">
        {{ item.status }}
      </td>
    </tr>
  </tbody>
</table>
<div *ngIf="tableauAAfficher && resultats.items.length === 0">Aucun r&eacute;sultat</div>
<br/>



// WEBPACK FOOTER //
// ./src/app/page/logs/logs.component.html